import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { ThemeProvider } from './context/ThemeContext';
import { LanguageProvider } from './context/LanguageContext';
import Navbar from './components/common/Navbar';
import Footer from './components/common/Footer';
import ErrorBoundary from './components/common/ErrorBoundary';
import ScrollToTop from './components/common/ScrollToTop';
import BackToTop from './components/common/BackToTop';
import ChatWidget from './components/chat/ChatWidget';
import AppRoutes from './routes/AppRoutes';

import './assets/scss/main.scss';

function App() {
  return (
    <Router>
      <ThemeProvider>
      <LanguageProvider>
      <AuthProvider>
        <CartProvider>
          <div className="d-flex flex-column min-vh-100">
            <ScrollToTop />
            <ErrorBoundary>
            <Navbar />
            <main className="flex-grow-1">
              <AppRoutes />
            </main>
            <Footer />
            </ErrorBoundary>
          </div>
          <BackToTop />
          <ChatWidget />
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            closeOnClick
            pauseOnHover
            theme="light"
          />
        </CartProvider>
      </AuthProvider>
      </LanguageProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App;
